import { useDataRoom } from '@/contexts/overview/dataroom/utils';
import { ContentLayout } from '@/pages/overview/common/ContentLayout';
import { RightSidePanel } from '@/pages/overview/common/side-panel/RightSidePanel';
import { DataRoomContent } from '@/pages/overview/dataroom/content/DataRoomContent';

export const DataRoomContentLayout = () => {
  const { selectedFile, sidePanelTabIndex, isSidePanelOpen } = useDataRoom();

  // Show sidebar if:
  // 1. A file is selected AND
  // 2. Sidebar panel is opened by user
  const shouldShowSidebar = selectedFile !== undefined && isSidePanelOpen;

  return (
    <ContentLayout
      content={<DataRoomContent />}
      sidebar={
        shouldShowSidebar && (
          <RightSidePanel pdfInteraction={false} sidePanelTabIndex={sidePanelTabIndex} />
        )
      }
    />
  );
};
